import Vue from 'vue';
import BzbsApi from '@/core/Http/BzbsApi.js';
import Account from '@/helper/AccountHelper.js';

/**
 * @method getPoint
 * @method getCustomerStore
 * @method getProfile
 * @method getCampaign
 */

export default {
	config: function() {
		return Vue.bzbsConfig;
	},
	token: function() {
		return Account.getCacheToken() ? Account.getCacheToken() : null
	},
	postEarnCode: function(obj) {
		let codes = [];
		for (let i = 0; i < obj.length; i++) {
			if (i < (obj.length - 1)) {
				codes += obj[i] + ',';
			} else {
				codes += obj[i];
			}
		}
		let params = {
			'codes[]': codes
		};
		var strUrl = this.config().bzbModuleUrl + '/point/code_earns';
		return BzbsApi.connectBzbsPost(strUrl, this.token(), params);
	},
	postCouponProcess: function(obj) {
		let codes = [];
		for (let i = 0; i < obj.length; i++) {
			if (i < (obj.length - 1)) {
				codes += obj[i] + ',';
			} else {
				codes += obj[i];
			}
		}
		let params = {
			'codes[]': codes
		};
		var strUrl = this.config().bzbModuleUrl + '/coupon/process';
		return BzbsApi.connectBzbsPost(strUrl, this.token(), params);
	}
};
